export default __webpack_public_path__ + "static/media/dark-green-tick.ec9bd331.svg";